import React from "react";
import { Badge } from "@/shared/components/ui/Badge";
import type { TaskColumn } from "@/features/tasks/types/task";

interface TaskStatusBadgeProps {
  column: TaskColumn;
}

type BadgeVariant = "default" | "success" | "warning" | "danger" | "info";

const colorToVariant: Record<string, BadgeVariant> = {
  slate: "default",
  blue: "info",
  green: "success",
  amber: "warning",
  red: "danger",
  purple: "default",
  pink: "default",
  indigo: "info",
};

export const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({ column }) => {
  const variant = colorToVariant[column.color] ?? "default";
  return <Badge variant={variant}>{column.label}</Badge>;
};
